import { useQuery } from "@tanstack/react-query";
import type { TWorkspace } from "../types";
import { getWorkspaceForMembers } from "../services";

export const useGetWorkspaceForMembers = (
  workspaceId: string,
  options?: { enabled?: boolean },
) => {
  return useQuery<TWorkspace>({
    queryKey: ["workspace-member", workspaceId],
    queryFn: ({ signal }) => getWorkspaceForMembers(workspaceId, signal),
    enabled: options?.enabled ?? !!workspaceId,
    retry: 1,
    staleTime: 1000 * 60 * 2,
  });
};
